// extracted by mini-css-extract-plugin
module.exports = {"Root":"packageSelection_Root__TBFDX","Title":"packageSelection_Title__3dpPO","Selected":"packageSelection_Selected__lS43X","Column":"packageSelection_Column__2BE7O"};